import type {
  HpsBoltOnDischargesQueryVariables,
  Bolt_On_Discharges_Bool_Exp
} from "gql/api";
import { Order_By } from "gql/api";

export function deleteHpsBoltOnDischarges(
  arr: Array<string>
): Bolt_On_Discharges_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}

export function restoreHpsBoltOnDischarges(
  arr: Array<string>
): Bolt_On_Discharges_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}

const order_by = [
  { manufacturer: Order_By.Asc },
  { series_model: Order_By.Asc },
  { tubing_diameter_inches: Order_By.Asc }
];

export const defaultHpsBoltOnDischargesVars: HpsBoltOnDischargesQueryVariables =
  {
    order_by,
    where: {
      is_hps: { _eq: true }
    }
  };

export const adminHpsBoltOnDischargesVars: HpsBoltOnDischargesQueryVariables = {
  order_by,
  where: {
    is_hps: { _eq: true }
  }
};

export const kocHpsBoltOnDischargesVars: HpsBoltOnDischargesQueryVariables = {
  order_by,
  where: {
    _and: [
      {
        _or: [
          { include_koc_timestamp: { _is_null: false } },
          { only_koc_timestamp: { _is_null: false } }
        ]
      },
      { is_hps: { _eq: true } }
    ]
  }
};

export const ecopetrolHpsBoltOnDischargesVars: HpsBoltOnDischargesQueryVariables =
  {
    order_by,
    where: {
      _and: [
        {
          _or: [
            { include_ecopetrol_timestamp: { _is_null: false } },
            { only_ecopetrol_timestamp: { _is_null: false } }
          ]
        },
        { is_hps: { _eq: true } }
      ]
    }
  };
